// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ir-0";